import api from "./api";

export default {
  async listar(filtroNombre?: string) {
    const params = filtroNombre ? `?ps_nombre=${filtroNombre}` : "";
    return api.get(`punto_servicio/todos${params}`);
  },
  // Nuevo: listar PS por fiscal (backend deberá implementar este endpoint)
  async listarPorFiscal(fiscalId: string, filtroNombre?: string) {
    const q = filtroNombre ? `&ps_nombre=${encodeURIComponent(filtroNombre)}` : ""; // Query opcional por nombre
    return api.get(`punto_servicio/por_fiscal?fiscal_id=${encodeURIComponent(fiscalId)}${q}`); // Endpoint sugerido
  },
  // Nuevo: obtener fiscal por PS usando ps_codigo
  async obtenerFiscalPorPs(psCodigo: string) {
    return api.get(`punto_servicio/fiscal_por_ps?ps_codigo=${encodeURIComponent(psCodigo)}`); // Endpoint real del backend
  },
};
